import {Container, DestroyOptions, Text, TextStyle} from "pixi.js";
import MarkData from "../types/MarkData.ts";
import DagobahModel from "@/models/DagobahModel.ts";
export default class MarkText extends Container
{
    private _markData:MarkData[];
    private textField:Text;

    public style:TextStyle;
    public text:string;

    public override get height(): number
    {
        return this.textField.height;
    }

    public get markData():MarkData[]
    {
        return this._markData;
    }

    public override get width(): number
    {
        return this.textField.width;
    }

    constructor(text?:string, style?:TextStyle)
    {
        super();
        this.text = text;
        this.style = style;
        this.createTextField();
    }

    private createTextField():void
    {
        this.textField = new Text({text:this.text, style:this.style});
        this.textField.resolution = DagobahModel.getInstance().devicePixelRatio;
        this.addChild(this.textField);
    }

    public addMarkData(markData:MarkData):void
    {
        if(!this._markData)
        {
            this._markData = [];
        }
        this._markData.push(markData);
    }

    public override destroy(options?: DestroyOptions | boolean)
    {
        super.destroy(options);
    }

}